import React, { createContext, useContext, useState } from 'react';
import { node } from 'prop-types';

const contextDefaultValue = {
  activeTab: 0,
};

const BackOfficeContext = createContext(contextDefaultValue);

const BackOfficeProvider = ({ children }) => {
  const [activeTab, setActiveTab] = useState(0);
  const value = {
    activeTab,
    setActiveTab,
  };

  return <BackOfficeContext.Provider value={value}>{children}</BackOfficeContext.Provider>;
};

BackOfficeProvider.propTypes = {
  children: node.isRequired,
};

const useBackOffice = () => {
  const context = useContext(BackOfficeContext);
  if (context === undefined) {
    throw new Error('useBackOffice must be used within provider');
  }
  return context;
};

export { BackOfficeProvider, BackOfficeContext, useBackOffice };
